import { ChatFloatingHeader } from "@hamlak/ui";

type Props = {
  name: string;
  avatarUrl?: string;
  onBack: () => void;
  onMenu: () => void;
};

/** 채팅방 헤더: ChatFloatingHeader(name·⋯). 모델명은 헤더에 표시하지 않는다(AC0-293). 내리면 배경이 깔린다(F03-24, useHeaderScrollBg). 비회원 ⋯는 로그인 시트. 브릭 잔액은 표시하지 않는다(AC0-231 — 잔액은 마이페이지·상점에서). */
export function ChatHeader({ name, avatarUrl, onBack, onMenu }: Props) {
  return (
    <ChatFloatingHeader
      className="chat__header"
      scrollBackground
      name={name}
      {...(avatarUrl ? { avatar: <img src={avatarUrl} alt="" className="chat__avatar" /> } : {})}
      onBack={onBack}
      onMenu={onMenu}
    />
  );
}
